import { RiDeleteBinLine } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import { Button } from "~/components/common/parts/button/Button";
import Styles from "./DeleteMenuButton.module.scss";

type Props = {
	children: ReactNode;
	onClick: () => void | Promise<void>;
};

export function DeleteMenuButton({ children, onClick }: Props) {
	return (
		<Button onClick={onClick} size="sm" variant="normal">
			<RiDeleteBinLine className={Styles.Icon} />
			{children}
		</Button>
	);
}
